import React, { Fragment } from "react"
import classnames from "classnames"

import styles from "./styles.css"

function FormSkeleton() {
  return (
    <Fragment>
      <div>
        <div
          className={classnames(styles.formSkeletonInputFull, styles.skeleton)}
        ></div>
        <InputHalf />
        <InputHalf />
        <div
          className={classnames(
            styles.formSkeletonInputFull,
            styles.skeleton,
            styles.containerInput
          )}
        ></div>
        <InputHalf />
      </div>
    </Fragment>
  )
}

const InputHalf = () => {
  return (
    <div className={classnames("u-flex", styles.containerInput)}>
      <div
        className={classnames(
          styles.formSkeletonInputHalf,
          styles.skeleton,
          styles.marginRight
        )}
      ></div>
      <div
        className={classnames(styles.formSkeletonInputHalf, styles.skeleton)}
      ></div>
    </div>
  )
}

export default FormSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/AutomaticDebitSkeleton/FormSkeleton.js